export interface PointAdjustConfigs {
	[key: string]: any;
}

export interface PointAdjustHistory {
	id: string;
	groupId: string;
	updateMemberId: string;
	memberId: string;
	memberCarId: string;
	point: number;
	reason: string;
	pointAdjustDay: number;
	baljuCount: number;
	sujuCount: number;
	baljuAmount?: number;
	sujuAmount?: number;
}

export interface PointAdjustRankingData {
	userId: string;
	id: string;
	pointAdjustHistory: PointAdjustHistory[];
	groupId: string;
	carType: CarTypeType;
	memberCarId: string;
	rank: number;
	name: string;
	nickname: string;
	number: string;
	point: number;
	baljuCount: number;
	sujuCount: number;
	baljuAmount?: number;
	sujuAmount?: number;
	preRank?: number;

	adjustPoint?: number;
	adjustBaljuCount?: number;
	adjustSujuCount?: number;
	adjustBaljuAmount?: number;
	adjustSujuAmount?: number;
	adjustReason?: string;
	adjustDate?: number;
}

export interface PointAdjustData {
	configs: PointAdjustConfigs;
	rankingData: PointAdjustRankingData[];
}

export type CarTypeType = 'all' | '1t' | '2t' | '3t' | '5t' | '5t_over' | '54m' | '58m' | '75m' | '54m_over' | '58m_over';

export type RankingPeriodType = 'pre_half_month' | 'this_half_month' | 'next_half_month' | 'pre_month' | 'this_month' | 'next_month' | 'last30' | 'last60' | 'last90' | 'all_time';

export interface GroupInfo {
	id: string;
	createDate: any;
	name: string;
	imgUrl: string;
	desc: string;
	signUpCondition: string;
	configs: any;
}

export const PointAdjustTableColumns = [
	{ key: 'history', title: '히스토리', width: 55 },
	{ key: 'ranking', title: '랭킹', width: 50 },
	{ key: 'car', title: '톤수/차량번호', width: 150 },
	{ key: 'name', title: '이름/닉네임', width: 150 },
	{ key: 'point', title: '총 점수', width: 80 },
	{ key: 'balju', title: '발주', width: 80 },
	{ key: 'suju', title: '수주', width: 80 },
	{ key: 'date', title: '적용 날짜', width: 180 },
	{ key: 'extraPoint', title: '추가 점수', width: 100 },
	{ key: 'extraBalju', title: '추가 발주', width: 100 },
	{ key: 'extraSuju', title: '추가 수주', width: 100 },
	{ key: 'reason', title: '조정 사유', width: 170 },
	{ key: 'adjust', title: '점수 조정', width: 85 },
];
